import * as types from './types'
import { MonitoringProxy } from 'services'

export const loadLogsAttempt = () => ({
  type: types.LOAD_LOGS_ATTEMPT
})

export const loadLogsSuccess = (logs) => ({
  type: types.LOAD_LOGS_SUCCESS,
  logs
})

export const loadLogsFailure = (error) => ({
  type: types.LOAD_LOGS_FAILURE,
  error
})

export const setParams = (hours, top) => ({
  type: types.SET_PARAMS,
  hours,
  top
})

export const resetMonitoring = () => ({
  type: types.RESET_MONITORING
})

export const loadLogs = (hours, top) => async (dispatch) => {
  try {
    dispatch(loadLogsAttempt())

    const proxy = new MonitoringProxy()
    const response = await proxy.getSummary(hours, top)

    dispatch(loadLogsSuccess(response))
  } catch (error) {
    dispatch(loadLogsFailure(error))
    throw error
  }
}
